import secondaryButtonColorBorderTextRule from '../../../../../common/algorithms/secondary-button-color-border-text-rule';

const dark = (params) => secondaryButtonColorBorderTextRule(params);

export default dark;
